/*
 * Copyright 2026 Sergey S. Chernov
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

package net.sergeych.lyng.bytecode

enum class CaptureOwnerFrameKind { MODULE, LOCAL }

data class LambdaCaptureEntry(
    val ownerKind: CaptureOwnerFrameKind,
    val ownerScopeId: Int,
    val ownerSlotId: Int,
    val ownerName: String,
    val ownerIsMutable: Boolean,
    val ownerIsDelegated: Boolean,
)

data class BytecodeCaptureEntry(
    val ownerKind: CaptureOwnerFrameKind,
    val ownerScopeId: Int,
    val ownerSlotId: Int,
    val slotIndex: Int,
)
